import INDEX_MODULE from '@/store/modules/CRM/booking/index'
import FILTER_MODULE from '@/store/modules/CRM/booking/filter'

const CRM_BOOKING = {
	namespaced: true,
	modules: {
		index: INDEX_MODULE,
		filter: FILTER_MODULE
	},
	state: {
		processing: false
	},
	getters: {

	},
	mutations: {
	},
	actions: {

	}
}

export default CRM_BOOKING
